export default __webpack_public_path__ + "static/media/trading-platform-desktop.32151e0d.jpg";